export enum ListingEvent {
    REFRESH = 'listing:refresh',
}

export interface ListingEventMap {
    [ListingEvent.REFRESH]: void;
}
